  const reportRoutes = {
    reports: "/reports",
    jobOfferReport: "/reports/job-offer-report",
    feedbackReport: "reports/feedback-report",
    sessionHistoryReport: "reports/session-history-report",
    scheduleComplianceReport: "reports/schedule-compliance-report",
    timeRequestReport: "reports/time-request-report",
    leaveHistoryReport: "reports/leave-history-report",
    timeEntryReport: "reports/time-entry-report",
    interviewReport: "reports/interview-report",
    contractReport: "reports/contract-report",
    insuranceReport: "reports/insurance-report",
  };

  export default reportRoutes;
